export default "__VITE_ASSET__tRS9Jvhh__"